"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _polished = require("polished");

var _default = {
  xxsmall: (0, _polished.rem)('2px'),
  xsmall: (0, _polished.rem)('4px'),
  small: (0, _polished.rem)('8px'),
  medium: (0, _polished.rem)('16px'),
  large: (0, _polished.rem)('24px'),
  xlarge: (0, _polished.rem)('32px'),
  xxlarge: (0, _polished.rem)('40px'),
  xxxlarge: (0, _polished.rem)('48px')
};
exports.default = _default;
//# sourceMappingURL=spacing.js.map